module.exports = __webpack_public_path__ + "static/media/14.e4260ae9.jpg";